<script setup lang="ts">
  import type { RouteLocationNormalized } from 'vue-router'

  import { BackwardIcon } from '@/shared/ui/svg'

  const props = withDefaults(
    defineProps<{
      label?: string
      route:
        | string
        | Partial<RouteLocationNormalized>
        | { name: string; params?: Record<string, unknown>; query?: Record<string, string> }
      strictRoute?: boolean
      type?: 'arrow' | 'rounded'
    }>(),
    {
      type: 'arrow',
    },
  )

  const routePath = computed(() => {
    const path =
      typeof props.route === 'string'
        ? props.route.startsWith('/')
          ? props.route
          : `/${props.route}`
        : { name: props.route.name, params: props.route.params, query: props.route.query }
    if (props.strictRoute) {
      return path
    } else if (window.history.state.back) {
      return window.history.state.back
    }
    return path
  })
</script>

<template>
  <RouterLink
    :class="['back__button', { 'back__button--rounded': type === 'rounded' }]"
    :to="routePath"
  >
    <BackwardIcon /> {{ label }}
  </RouterLink>
</template>

<style scoped lang="scss">
  .back__button {
    @include flex-container(row, flex-start, center);
    @include font-montserrat-500(14px, 17px);
    color: var(--text-content);
    text-decoration: none;
    width: fit-content;
    cursor: pointer;
    gap: 6px;

    &--rounded {
      justify-content: center;
      border-radius: 100px;
      background-color: var(--white-5);
      padding: 6px 12px;
      width: 30px;
      height: 30px;
      color: var(--dark-black);
      font-size: 14px;
      line-height: 17px;
      text-decoration: none;
    }
  }
</style>
